<template>
  <div class="flex size-full lg:justify-end">
    <div class="flex w-full divide-x divide-gray-lightest overflow-hidden rounded-xl border border-gray-lightest lg:w-auto lg:flex-col-reverse lg:items-end lg:divide-x-0 lg:divide-y lg:divide-y-reverse">
      <button
        class="flex basis-1/2 items-center justify-center bg-white p-4"
        :class="{'cursor-auto opacity-50': !hasPrev}"
        @click="hasPrev && emit('prev')"
      >
        <span class="sr-only">Vorige</span>
        <IconsControlNext class="rotate-180 stroke-gray" />
      </button>
      <button
        class="flex basis-1/2 items-center justify-center bg-white p-4"
        :class="{'cursor-auto opacity-50': !hasNext}"
        @click="hasNext && emit('next')"
      >
        <span class="sr-only">Volgende</span>
        <IconsControlNext class="stroke-gray" />
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  size: number
  page: number
  hasNext: boolean
  hasPrev: boolean
}>();

const emit = defineEmits<{
  (e: 'next'): void,
  (e: 'prev'): void
}>();
</script>
